export const DEFAULTS_API_TIMEOUT_KEY = 'API_DEFAULTS_TIMEOUT';
export const DEFAULTS_API_TIMEOUT_VALUE = 301000;

export const DATATYPE_COLUMN_WIDTH = {
  date: 120,
  datetime: 150,
  default: 200,
  popup: 200
};
export const DEFAULT_CONFIG_URL = '/config-file';
export const DEFAULT_OPERATION_COLUMN_WIDTH = 160;

// excel(*.xls)
export const EXCLE_XLS = 'application/vnd.ms-excel';

// excel(*.xlsx)
export const EXCEL_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const STATION = {
  PURCHASE: 'purchase',
  SALE: 'sale'
};

export const DEFAULT_PAGER_COUNT = 5;
export const DIALOG_TABLE_MAX_HEIGHT = 600;
